<template>
  <div class="content-box">
    <table class="table">
      <thead>
        <tr>
          <th>Sku</th>
          <th>Nombre</th>
          <th>Existencia</th>
        </tr>
      </thead>
      <tbody>
        <tr
          :key="detalle.id"
          v-for="detalle in current"
          :class="{
            'text-danger': detalle.cantidad < 0,
          }"
        >
          <td>{{ detalle.sku }}</td>
          <td>{{ detalle.nombre_sku }}</td>
          <td>{{ detalle.cantidad }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ModalAsignarProductosATarimaComponent from "@/components/wms/tarimas/ModalAsignarProductosATarimaComponent";

export default {
  components: {
    ModalAsignarProductosATarimaComponent,
  },
  props: {
    current: {
      type: Array,
    },
  },
  data() {
    return {};
  },

  mounted() {},
  methods: {
    Imprimir(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      current;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/tarima.jrxml&id=${self.id}`
      );
    },
    regresarClick() {
      this.$emit("regresar");
    },
    refresh_tarima() {
      this.$emit("seleccionarPosicion", this.current.id);
    },
  },
};
</script>
